import { createSlice } from '@reduxjs/toolkit';

export const servicesIaUsageMonthlysSlice = createSlice({
    name: 'servicesIaUsageMonthlys',
    initialState: {
        services_ia_usage_monthlys_list: [],
        services_ia_usage_monthlys: {},
        customers_for_select: []
    },
    reducers: {
        setServicesIaUsageMonthlysListRedux: ( state, { payload } ) => {
            state.services_ia_usage_monthlys_list  =  payload;
        }, 
        setServicesIaUsageMonthlysRedux: ( state, { payload } ) => {
            state.services_ia_usage_monthlys  =  payload; 
        },
        setCustomersForSelectMonthlyRedux: ( state, { payload } ) => {
            state.customers_for_select  =  payload; 
        }   
    }
});

// Action creators are generated for each case reducer function
export const { setServicesIaUsageMonthlysListRedux, setServicesIaUsageMonthlysRedux, setCustomersForSelectMonthlyRedux } = servicesIaUsageMonthlysSlice.actions;
